<template>
  <t-table
    :local-data="payees"
    :columns="columns"
    :options="options"
  >

  </t-table>
</template>

<script>

import { capitalize } from "lodash"

export default {
  name: "RightsHolderPayees",
  props: {
    rightsholderId: String
  },
  data () {
    return {
      payees: [],
      columns: ["id", "name", "split", "memberCollective"],
      options: {
        sortable: ["id", "name", "split", "memberCollective"],
        headings: {
          id: "ID",
          name: capitalize(this.$t("name")),
          split: capitalize(this.$t("percentage")),
          memberCollective: capitalize(this.$t("member_collective"))
        }
      }
    }
  },
  mounted () {
    this.$api.rightsholders.rightsholdersPayeesList(this.rightsholderId).then(response => {
      this.payees = response.data
    })
  }
}

</script>

